/**
 * Created by Ganesh.Sharma on 26-08-2016.
 */

define([], () => {
return ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
return {
standardAddress: (callGroups, AddressRequestDTO) => {
const deferred = $q.defer();
        JsonRPCService.send('addressstandardization', 'standardization', 'standardAddress', [AddressRequestDTO], callGroups).then(
        (AddressResponse) => deferred.resolve(AddressResponse),
        (error, status, headers) => deferred.reject([error, status, headers]));
        return deferred.promise;
        }
};
}];
        });



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/addressstandardization/services/AddressStandardizationService.js
 **/